import React, { useEffect, useRef, useState } from "react";
import { ActiveStarIcon, DeleteIcon, DownloadIcon, EditIcon, MoveIcon, RestoreIcon, StarIcon } from "../Icons";

const ActionPopup = ({
  isFolder = false,
  file,
  rename,
  handleDelete,
  move,
  download,
  favourite,
  handleRestore
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const popupRef = useRef(null);

  const handleOpenPop = () => {
    setOpenPopup(true);
  };

  useEffect(() => {
    if (!openPopup) return;
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpenPopup(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openPopup]);
  return (
    <div className="relative">
      <button
        className="border-0 bg-transparent"
        onClick={(e) => {
          e.stopPropagation();
          handleOpenPop();
        }}
      >
        <svg
          width="3"
          height="13"
          viewBox="0 0 3 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.25 12.1154C0.90625 12.1154 0.612014 11.993 0.367292 11.7481C0.122431 11.5034 0 11.2092 0 10.8654C0 10.5217 0.122431 10.2274 0.367292 9.9825C0.612014 9.73778 0.90625 9.61542 1.25 9.61542C1.59375 9.61542 1.88799 9.73778 2.13271 9.9825C2.37757 10.2274 2.5 10.5217 2.5 10.8654C2.5 11.2092 2.37757 11.5034 2.13271 11.7481C1.88799 11.993 1.59375 12.1154 1.25 12.1154ZM1.25 7.30771C0.90625 7.30771 0.612014 7.18528 0.367292 6.94042C0.122431 6.6957 0 6.40146 0 6.05771C0 5.71396 0.122431 5.41972 0.367292 5.175C0.612014 4.93014 0.90625 4.80771 1.25 4.80771C1.59375 4.80771 1.88799 4.93014 2.13271 5.175C2.37757 5.41972 2.5 5.71396 2.5 6.05771C2.5 6.40146 2.37757 6.6957 2.13271 6.94042C1.88799 7.18528 1.59375 7.30771 1.25 7.30771ZM1.25 2.5C0.90625 2.5 0.612014 2.37764 0.367292 2.13292C0.122431 1.88806 0 1.59375 0 1.25C0 0.90625 0.122431 0.612014 0.367292 0.367292C0.612014 0.122431 0.90625 0 1.25 0C1.59375 0 1.88799 0.122431 2.13271 0.367292C2.37757 0.612014 2.5 0.90625 2.5 1.25C2.5 1.59375 2.37757 1.88806 2.13271 2.13292C1.88799 2.37764 1.59375 2.5 1.25 2.5Z"
            fill="#333333"
          />
        </svg>
      </button>
      {openPopup && (
        <div className="absolute top-[40px] right-[1px] z-[2005] ">
          <div
            ref={popupRef}
            className="p-[18px] shadow-[0px_4px_25px_0px_#0000000D] rounded-[10px] bg-white flex flex-col gap-[14px] w-fit border border-[#ECECEB]"
          >
            {rename && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  rename(file);
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                <EditIcon />
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Rename
                </span>
              </button>
            )}
            {move && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  move(file);
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                <MoveIcon />
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Move
                </span>
              </button>
            )}
            {favourite && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  favourite(file);
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                {file?.is_favorite ? 
                <ActiveStarIcon /> : <StarIcon />}
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Favourite
                </span>
              </button>
            )}
            {handleRestore && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleRestore(file);
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                <RestoreIcon />
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Restore 
                </span>
              </button>
            )}
            {download && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isFolder) {
                    download(file?.s3_url, file?.file_name);
                  } else {
                    download(file?.id, file?.folder_name);
                  }
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                <DownloadIcon />
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Download
                </span>
              </button>
            )}
            {handleDelete && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(file);
                }}
                className="flex items-center gap-2 border-0 bg-transparent"
              >
                <DeleteIcon />
                <span className="text-[0.9rem] font-normal text-[#232323]">
                  Delete
                </span>
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionPopup;
